<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,TruCOLOR Porcelain Enamel"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Porcelain enamel paints baked on a steel substrate</div><br>
        <div>TruCOLOR Porcelain Enamel signs are widely recognized as the best exterior sign product for true color
          reproduction. In addition, they carry the best warranty in exterior conditions of any exterior, full-color
          digital product (25 years against any deterioration). The basic product is porcelain enamel paint, baked
          on a 1/16" thick steel substrate. Studs may be welded to the back of the sign and edges are square or
          flanged.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign01.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign02.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign03.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign04.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign05.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign06.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign07.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign08.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign09.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign10.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign11.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign12.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign13.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign14.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign15.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign16.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign17.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign18.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign19.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign20.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign21.jpg'),
          require('@/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign22.jpg')
        ],
        type: Array
      }
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'TruCOLOR Porcelain Enamel'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/TruColor.vue